import { browserTracingIntegration, feedbackIntegration, init } from '@sentry/vue';
import type { App } from 'vue';
import type { Router } from 'vue-router';

import { UNRESOLVED_ROUTE_COMPONENT_ERROR } from '@/config/errorHandling.ts';
import { viteSentryEnabled } from '@/config/env.ts';
import { redactSensitive } from '@/utils/secretRedaction.ts';

export function setupSentry(app: App, router: Router) {
  if (!viteSentryEnabled) return;

  init({
    app,
    environment: import.meta.env.MODE,
    dsn: import.meta.env.VITE_SENTRY_DSN,
    release: import.meta.env.VITE_APP_VERSION,
    integrations: [
      browserTracingIntegration({
        tracePropagationTargets: [
          new RegExp(
            `^${import.meta.env.VITE_API_URL.replace(/:\//g, '://').replace(/\./g, '\\.')}`,
          ),
        ],
        router,
      }),
      feedbackIntegration({
        autoInject: false,
      }),
    ],
    tracesSampleRate: 1.0,
    // router.onError does not stop the navigation promise from rejecting
    ignoreErrors: [UNRESOLVED_ROUTE_COMPONENT_ERROR],
    // Credential-redaction backstop on every off-site payload;
    beforeSend: redactSensitive,
    beforeSendTransaction: redactSensitive,
    beforeBreadcrumb: redactSensitive,
  });
}
